module.exports = __webpack_public_path__ + "img/Fabella_island_raw.1128c66e.png";